import { useEffect, useRef } from 'react';

// Lightweight event bus for tour 'custom' gates.
// Pages emit named events (e.g. 'wizard.step', 'workout.first-set-completed')
// via useTourEvent or emit(); the active TourProvider subscribes to listen.

const subscribers = new Map(); // eventName -> Set<callback>

export function emit(eventName, payload) {
  const subs = subscribers.get(eventName);
  if (!subs) return;
  subs.forEach((cb) => {
    try { cb(payload); } catch { /* ignore */ }
  });
}

export function subscribe(eventName, callback) {
  if (!subscribers.has(eventName)) subscribers.set(eventName, new Set());
  subscribers.get(eventName).add(callback);
  return () => {
    subscribers.get(eventName)?.delete(callback);
  };
}

// React hook used by tour-aware pages to emit events when a tracked value changes.
// Skips emission when payload is undefined, so callers can pass undefined to suppress.
export function useTourEvent(eventName, payload) {
  const lastRef = useRef(undefined);
  useEffect(() => {
    if (payload === undefined) return;
    if (lastRef.current !== payload) {
      lastRef.current = payload;
      emit(eventName, payload);
    }
  }, [eventName, payload]);
}
